// Instead of this, considering phx-trigger-action
// Add a dropdown to the screenshot

const areaListener = new AbortController();

export const Arcade = {
  mounted() {
    this.csrfToken = document.querySelector('meta[name=csrf-token]')?.getAttribute('content');
    this.updateArcadePath = this.el.dataset.updateArcadePath;
    this.restoreDefaultsPath = this.el.dataset.restoreDefaultsPath;

    this.arcadeData = JSON.parse(this.el.dataset.arcade);

    this.el.addEventListener('toggle-setting', (ev) => this.toggleSetting(ev.detail.setting));
    this.el.addEventListener('restore-defaults', () => this.restoreDefaults());
    this.el.addEventListener('select-option', (ev) => {
      this.selectOption(ev.detail.selection);
    });

    // Drag & Resize
    this.isDrag = false;
    this.isResize = false;
    this.onResize = false;

    this.start = {
      x: 0,
      y: 0,
    };

    this.curr = {
      x: 0,
      y: 0,
    };

    this.style = {
      top: 0,
      left: 0,
    };

    this.resizeDirection = '';
    this.start = this.handleStart.bind(this)
    this.drag = this.handleDrag.bind(this);
    this.resize = this.handleResizePanel.bind(this);
    this.end = this.handleEnd.bind(this);
    this.minimize = this.minimizePanel.bind(this);
    this.expand = this.expandPanel.bind(this)

    this.arcadeHeader = document.getElementById('arcade-header');
    this.arcadePanel = document.getElementById('arcade-elc-panel');
    this.arcadeTrigger = document.getElementById('arcade-trigger');
    this.arcadeMinimizeButton = document.getElementById('arcade-minimize-button');
    this.arcadeExpandButton = document.getElementById('arcade-expand-button');

    this.arcadeHeader.addEventListener("mousedown", e => {
      e.preventDefault();
      this.isDrag = true; 
    });
    this.arcadePanel.addEventListener("mousedown", this.start);
    this.arcadePanel.addEventListener("mousemove", this.handleResize.bind(this));

    this.arcadeHeader.addEventListener("touchstart", this.start);
    this.arcadeHeader.addEventListener("touchmove", this.drag);

    document.addEventListener("mouseup", this.end);
    document.addEventListener("touchend", this.end);

    this.arcadeMinimizeButton.addEventListener("click", this.minimize)
    this.arcadeExpandButton.addEventListener("click", this.expand)

    // Hold to remove Arcade
    this.closeArcadeListener();
  },

  toggleSetting(setting) {
    this.updateArcade(setting, !this.arcadeData[setting]);
  },

  selectOption(selection) {
    this.updateArcade('selected_loki_env', selection);
  },

  async updateArcade(key, value) {
    const resp = await fetch(this.updateArcadePath, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.csrfToken
      },
      body: JSON.stringify({ var: key, val: value })
    });

    const respJson = await resp.json();

    this.pushEventTo(this.el, 'update-arcade', respJson);
  },

  async restoreDefaults() {
    const resp = await fetch(this.restoreDefaultsPath, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.csrfToken
      }
    });

    await resp.json();
    this.pushEventTo('#revision-tag-select', 'clear-revision-tag');
  },

  updated() {
    this.arcadeData = JSON.parse(this.el.dataset.arcade);
  },

  closeArcadeListener() {
    const closeHoldDuration = 1500;
    const closeHoldWiggleDuration = 500;
    let timerId;
    let wiggleTimerId;

    const holdEvent = () => {
      wiggleTimerId = setTimeout(() => {
        this.arcadeTrigger.classList.add('wiggle');
      }, closeHoldWiggleDuration);
      
      timerId = setTimeout(() => {
        this.el.remove()
      }, closeHoldDuration);
    }

    const clearEvent = (e) => {
      this.arcadeTrigger.classList.remove('wiggle');
      clearTimeout(timerId);
      clearTimeout(wiggleTimerId);
    }

    this.arcadeTrigger.addEventListener('mousedown', holdEvent);
    this.arcadeTrigger.addEventListener('mouseup', clearEvent);
    this.arcadeTrigger.addEventListener('mouseleave', clearEvent);
    this.arcadeTrigger.addEventListener('touchstart', holdEvent);
    this.arcadeTrigger.addEventListener('touchend', clearEvent);
    document.addEventListener('touchmove', clearEvent);
    document.addEventListener('touchcancel', clearEvent);
  },

  handleStart(e) {
    // if middle or right click end grab/resize session
    if (e.button === 1 || e.button === 2) {
      this.end();
      return;
    }

    // if not left mouse click, return
    if (e.button !== 0 && e.type !== "touchstart") { return; }

    this.arcadePanel.focus();

    this.start.x = e.clientX ?? e.touches[0].clientX;
    this.start.y = e.clientY ?? e.touches[0].clientY;

    if (this.isResize) {
      e.preventDefault();
      this.onResize = true;
      document.addEventListener("mousemove", this.resize);
    } else if (this.isDrag) {
      e.preventDefault();
      this.arcadeHeader.style.cursor = 'grabbing';
      document.addEventListener("mousemove", this.drag);
    }
  },

  handleDrag(e) {
    e.preventDefault();
    this.arcadeHeader.style.cursor = 'grabbing';
    const x = e.clientX ?? e.touches[0].clientX;
    const y = e.clientY ?? e.touches[0].clientY;

    this.curr.x = x - this.start.x;
    this.curr.y = y - this.start.y;

    this.start.x = x;
    this.start.y = y;

    const rect = this.arcadePanel.getBoundingClientRect();

    this.style.top = rect.top + this.curr.y;
    this.style.left = rect.left + this.curr.x;

    this.arcadePanel.style.top = this.style.top + "px";
    this.arcadePanel.style.left = this.style.left + "px";
  },

  handleEnd() {
    this.isDrag = false;
    this.isResize = false;
    this.onResize = false;
    this.resizeDirection = '';

    document.removeEventListener("mousemove", this.drag);
    document.removeEventListener("mousemove", this.resize);

    this.arcadeHeader.style.removeProperty('cursor');
    this.arcadePanel.style.removeProperty('cursor');
  },

  handleResize(e) {
    if (this.onResize) { return; }
    const x = e.clientX ?? e.touches[0].clientX;
    const y = e.clientY ?? e.touches[0].clientY;

    const rect = this.arcadePanel.getBoundingClientRect();

    const isNearBottom: boolean = y <= rect.bottom && y > rect.bottom - 10;
    const isNearLeft: boolean = x >= rect.left && x < rect.left + 10;
    const isNearRight: boolean = x <= rect.right && x > rect.right - 10;
    const isNearTop: boolean = y >= rect.top && y < rect.top + 10;

    if (isNearLeft && isNearTop) {
      this.isResize = true;
      this.resizeDirection = 'top-left'
      this.arcadeHeader.style.cursor = 'nwse-resize';
    } else if (isNearRight && isNearTop) {
      this.isResize = true;
      this.resizeDirection = 'top-right'
      this.arcadeHeader.style.cursor = 'nesw-resize';
    } else if (isNearLeft && isNearBottom) {
      this.isResize = true;
      this.resizeDirection = 'bottom-left'
      this.arcadePanel.style.cursor = 'nesw-resize';
    } else if (isNearRight && isNearBottom) {
      this.isResize = true;
      this.resizeDirection = 'bottom-right'
      this.arcadePanel.style.cursor = 'nwse-resize';
    } else if (isNearTop) {
      this.isResize = true;
      this.resizeDirection = 'top'
      this.arcadeHeader.style.cursor = 'ns-resize';
    } else if (isNearBottom) {
      this.isResize = true;
      this.resizeDirection = 'bottom'
      this.arcadePanel.style.cursor = 'ns-resize';
    } else if (isNearLeft) {
      this.isResize = true;
      this.resizeDirection = 'left'
      this.arcadePanel.style.cursor = 'ew-resize';
    } else if (isNearRight) {
      this.isResize = true;
      this.resizeDirection = 'right'
      this.arcadePanel.style.cursor = 'ew-resize';
    } else {
      this.isResize = false;
      this.resizeDirection = '';
      this.arcadeHeader.style.removeProperty('cursor')
      this.arcadePanel.style.removeProperty('cursor')
    }
  },

  handleResizePanel(e) {
    switch (this.resizeDirection) {
      case 'top':
        this.resizeTop(e);
        break;
      case 'bottom':
        this.resizeBottom(e);
        break;
      case 'left':
        this.resizeLeft(e);
        break;
      case 'right':
        this.resizeRight(e);
        break;
      case 'top-left':
        this.resizeTop(e);
        this.resizeLeft(e);
        break;
      case 'top-right':
        this.resizeTop(e);
        this.resizeRight(e);
        break;
      case 'bottom-left':
        this.resizeBottom(e);
        this.resizeLeft(e);
        break;
      case 'bottom-right':
        this.resizeBottom(e);
        this.resizeRight(e);
        break;
      default:
        return;
    }
  },

  resizeTop(e) {
    this.setCoordinateY(e);

    const rect = this.arcadePanel.getBoundingClientRect();

    this.style.top = rect.top + this.curr.y;

    this.arcadePanel.style.top = this.style.top + 'px';
    this.arcadePanel.style.height = this.arcadePanel.offsetHeight - this.curr.y + 'px';
  },

  resizeBottom(e) {
    this.setCoordinateY(e);

    const rect = this.arcadePanel.getBoundingClientRect();

    this.style.top = rect.bottom - this.curr.y;

    this.arcadePanel.style.bottom = this.style.bottom + 'px';
    this.arcadePanel.style.height = this.arcadePanel.offsetHeight + this.curr.y + 'px';
  },

  resizeLeft(e) {
    this.setCoordinateX(e);

    const rect = this.arcadePanel.getBoundingClientRect();

    this.style.left = rect.left + this.curr.x;

    this.arcadePanel.style.left = this.style.left + "px";
    this.arcadePanel.style.width = this.arcadePanel.offsetWidth - this.curr.x + 'px';
  },

  resizeRight(e) {
    this.setCoordinateX(e);

    const rect = this.arcadePanel.getBoundingClientRect();

    this.style.right = rect.right + this.curr.x;

    this.arcadePanel.style.right = this.style.right + "px";
    this.arcadePanel.style.width = this.arcadePanel.offsetWidth + this.curr.x + 'px';
  },

  setCoordinateY(e) {
    const y = e.clientY ?? e.touches[0].clientY;
    this.curr.y = y - this.start.y;
    this.start.y = y;
  },

  setCoordinateX(e) {
    const x = e.clientX ?? e.touches[0].clientX;
    this.curr.x = x - this.start.x;
    this.start.x = x;
  },

  minimizePanel(e) {
    this.arcadePanel.removeAttribute('style');
  },

  expandPanel(e) {
    this.arcadePanel.style.height = "calc(100% - 2rem)";
    this.arcadePanel.style.width = "calc(100% - 2rem)";
    this.arcadePanel.style.bottom = "1rem";
    this.arcadePanel.style.top = "1rem";
    this.arcadePanel.style.left = window.innerWidth >= 1536 ? 'calc((100vw - 1536px) / 2)' : '1rem'; 
  }
};
